import { render, staticRenderFns } from "./addOutbound.vue?vue&type=template&id=3651c4d8&scoped=true&"
import script from "./addOutbound.vue?vue&type=script&lang=js&"
export * from "./addOutbound.vue?vue&type=script&lang=js&"
import style0 from "./addOutbound.vue?vue&type=style&index=0&id=3651c4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651c4d8",
  null
  
)

export default component.exports